import { Navigate, Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import Loader from "./components/Loader/Index";

const ProtectedRoute = () => {
  const [isAuthChecked, setIsAuthChecked] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = sessionStorage.getItem("q2p_token");
    setIsAuthenticated(!!token);
    setIsAuthChecked(true);
  }, []);

  if (!isAuthChecked) {
    return (
      <div>
        <Loader />
      </div>
    );
  }
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
